import {
  ProductDetail,
  ProductStore,
  Promotion,
  Upselling,
} from '@/hooks/use-cart-product/store'

export type ProductStoreFields = {
  selectedUpSelling: string
  promotion: Promotion
  products: ProductDetail
  upSellingProducts: Upselling
  currentProducts: ProductDetail
  externalPaymentMethod: string[]
  totalAmount: number
  totalAmountWithDiscount: number
}

//fields
export const promotionCodeSelector = (state: ProductStore) => state.promotion
export const customerDiscountSelector = (state: ProductStore) =>
  state.customerDiscounts
export const selectedUpSellingSelector = (state: ProductStore) =>
  state.selectedUpSelling
export const productsSelector = (state: ProductStore) => state.products
export const upSellingProductsSelector = (state: ProductStore) =>
  state.upSellingProducts
export const totalAmountSelector = (state: ProductStore) => state.totalAmount
export const totalAmountWithDiscountSelector = (state: ProductStore) =>
  state.totalAmountWithDiscount

export const productFieldsSelector = (state: ProductStore) => {
  return {
    selectedUpSelling: state.selectedUpSelling,
    promotion: state.promotion,
    products: state.products,
    upSellingProducts: state.upSellingProducts,
    totalAmount: state.totalAmount,
    totalAmountWithDiscount: state.totalAmountWithDiscount,
    currentProducts: state.currentProducts,
    externalPaymentMethod: state.external_pm,
  }
}

//sets
export const setUpsellingSelector = (state: ProductStore) => state.setUpselling
export const setProductsSelector = (state: ProductStore) => state.setProducts
export const setUpsellingProductsSelector = (state: ProductStore) =>
  state.setUpsellingProducts
export const setPromotionSelector = (state: ProductStore) => state.setPromotion
export const setCustomerDiscountsSelector = (state: ProductStore) =>
  state.setCustomerDiscounts
export const setStoreSelector = (state: ProductStore) => state.setStore
export const resetSelector = (state: ProductStore) => state.reset
